import './badge.css';
export default {
  "badge": "pf-v5-c-badge",
  "modifiers": {
    "read": "pf-m-read",
    "unread": "pf-m-unread"
  },
  "themeDark": "pf-v5-theme-dark"
};